export default __webpack_public_path__ + "static/media/login-message.66963b4b.png";